import React, { useState } from 'react';
function FruitsZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Condition</th>
          <th > Résultats</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Seuil de Zakat sur les fruits et cultures</td>
          <td>{result.threshold} (kg)</td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en fruits)</td>
          <td>{result.fruitsZakatAmount} (kg) </td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en espèces)</td>
          <td>{result.moneyZakatAmount}</td>
        </tr>
      </tbody>
    </table>
  );
}
export default FruitsZakatTable;
